import { AccountMap } from '../models/AccountMap';
import { Injectable, Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()

export class AccountMappingService {
private readonly AccountMappingEndPoint = '/api/AccountMapping';

constructor (private http: HttpClient) { }

getAccountMapping(component: string)
    {
        console.log('inside the account mapping');
        return this.http.get(this.AccountMappingEndPoint + '?component=' + component);
        
    }

    updateAccountMap(accMap: AccountMap)
    {
        console.log(accMap);
        return this.http.post(this.AccountMappingEndPoint,accMap);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/AccountMappingService.ts